import { NBSP } from 'shared/constants';
import { IOfferForMobileSiteSchema } from 'shared/repositories/search-engine/entities/offer/OfferForMobileSiteSchema';
import { priceToString } from 'shared/utils/formatters/price';

export const preparePrice = ({ discount, category, price }: IOfferForMobileSiteSchema) => {
  if (discount) {
    return discount.newPrice;
  }

  const isOfferDailyCategory = category.includes('daily');

  const formattedPrice = priceToString(price);

  return isOfferDailyCategory ? `от${NBSP}${formattedPrice}` : formattedPrice;
};
